import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { API_URL } from '../_common/constants';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CommonService } from './common.service';
import { PsiData } from '../_models/psi-data';

@Injectable({
  providedIn: 'root'
})
export class ReportsService {

  constructor(private http: HttpClient, private commonService: CommonService) { }

  set header(data: any){
    this.commonService.header = data;
  }
  
  get runningServices(){
    return this.commonService.runningServices;
  }

  fetchPendingCancellations(){
    return this.http.get<any>(API_URL.PendingCancellations, {observe: 'response'})
    .pipe(map(policies => {
        return policies.body.result;
    }));
  }

  storeAccountData(account){
    let psiData:PsiData = JSON.parse(sessionStorage.getItem('psiData'));
    psiData.selectedAccount = account;
    this.commonService.storeData(psiData);
  }

  fetchClaimAcknowledgementReport() {
    return this.http.get<any>(API_URL.ClaimAcknowledgement, {observe: 'response'})
    .pipe(map(response => {
        return response.body.result;
    }));
  }
}